import { MagpieConnection } from 'magpie-lib/connection';
import { useAppDispatch } from '../../../hooks/redux';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
import { navVisibilityControls } from 'navigation-messaging/messages';
import { toolbarAndNavDisplayConfig } from '../../../overlayDisplayConfig/actions';
import { OverlayType } from '../../../overlayDisplayConfig/interface';
import { appOverlayDisplayConfig } from '../../../overlayDisplayConfig/actions';
import { useCallback, useEffect } from 'react';
import { useNavigationVisibility } from '../../../hooks/useNavigationVisibility';
import { Metrics } from 'unified-navigation-ui/utils/metrics';
import { PUBLIC_API_METHODS, PUBLIC_API_USED } from '../../../constants/metrics';
const filter = ({
  senderFrameId
}, {
  frameId
}) => senderFrameId === frameId;

/**
 * Hook for handling navigation visibility via Public API
 * Manages both overlay display config for component rendering and dimensions for layout
 */
export const useVisibilityPublicApi = () => {
  const dispatch = useAppDispatch();
  const {
    setNavigationVisibility,
    isToolbarVisible,
    isVerticalNavVisible
  } = useNavigationVisibility();
  const onChangeNavVisibility = useCallback(({
    payload: {
      shouldShowToolbar,
      shouldShowVerticalNav,
      source
    }
  }, {
    reply
  }) => {
    Metrics.counter(PUBLIC_API_USED, {
      action: PUBLIC_API_METHODS.CHANGE_NAV_VISIBILITY
    }).increment();
    const configureOverlayAction = appOverlayDisplayConfig({
      appName: source !== null && source !== void 0 ? source : null,
      [OverlayType.PUBLIC_API]: {
        shouldShowToolbar,
        shouldShowNav: shouldShowVerticalNav
      }
    });
    const displayOverlayAction = toolbarAndNavDisplayConfig({
      isOverlayOpen: true,
      overlayType: OverlayType.PUBLIC_API
    });
    dispatch(configureOverlayAction);
    dispatch(displayOverlayAction);
    setNavigationVisibility({
      isToolbarVisible: shouldShowToolbar,
      isVerticalNavVisible: shouldShowVerticalNav
    });
    const visibilityChanged = navVisibilityControls.navVisibilityChanged.create({
      isToolbarVisible: shouldShowToolbar,
      isVerticalNavVisible: shouldShowVerticalNav
    });
    reply(visibilityChanged);
  }, [dispatch, setNavigationVisibility]);
  const onGetNavVisibility = useCallback((_, {
    reply
  }) => {
    Metrics.counter(PUBLIC_API_USED, {
      action: PUBLIC_API_METHODS.GET_NAV_VISIBILITY
    }).increment();
    reply(navVisibilityControls.navVisibility.create({
      isToolbarVisible,
      isVerticalNavVisible
    }));
  }, [isToolbarVisible, isVerticalNavVisible]);
  useEffect(() => {
    const topic = MagpieConnection.get().useTopic(navigationPublicApiTopicDef);
    const unsub1 = topic.on(navVisibilityControls.changeNavVisibility.getType(), onChangeNavVisibility, {
      filter
    });
    const unsub2 = topic.on(navVisibilityControls.getNavVisibility.getType(), onGetNavVisibility, {
      filter
    });
    return () => {
      unsub1();
      unsub2();
    };
  }, [onChangeNavVisibility, onGetNavVisibility]);
  return {
    setNavigationVisibility
  };
};